export const CONTENT_TYPE_HEADER = 'Content-Type'
export const AUTHORIZATION_HEADER = 'Authorization'
export const JSON = 'application/json'
export const ACCESS_CONTROL_ALLOW_ORIGIN = 'Access-Control-Allow-Origin'
